import { datadogRum } from '@datadog/browser-rum';
import { RouteLocationNormalized } from 'vue-router';
import { resolveCreditoNavigationRedirect } from '@/features/credito/routing/creditoRouteGuard';
import { sessionService } from '@/services';

/**
 * Guard global: login + delegação da jornada de crédito (regras em `creditoRouteGuard`).
 */
export default function authGuard(to: RouteLocationNormalized, from: RouteLocationNormalized): string | boolean {
  if (to.path === '/login' && sessionService.isLoggedIn) {
    datadogRum.addAction('sys:auth:login-redirect', {
      isLoggedIn: sessionService.isLoggedIn,
    });

    if (from.path === '/login' || !from.fullPath) return '/';

    return from.fullPath;
  }

  const creditoRedirect = resolveCreditoNavigationRedirect(to);
  if (creditoRedirect !== true) {
    return creditoRedirect;
  }

  return true;
}
